import { cn } from "../../../lib/utils";

export function TextareaField({
  item,
  value,
  error,
  helperText,
  disabled,
  onChange,
  onBlur,
  className,
}) {
  return (
    <textarea
      placeholder={item.placeholder}
      value={value || ""}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      rows={item.rows || 4}
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm",
        "ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none",
        "focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        error && "border-red-500 hover:border-red-500 focus:border-red-500",
        className
      )}
    />
  );
}
